module.exports = __webpack_public_path__ + "img/notice-qrcode.44721848.png";